import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "tw-flex tw-items-center" }
const _hoisted_2 = ["for"]
const _hoisted_3 = {
  key: 0,
  class: "tw-mt-1 tw-text-xs tw-text-slate-500"
}
const _hoisted_4 = ["id", "data-testid", "name", "value", "title", "disabled"]
const _hoisted_5 = {
  disabled: "",
  value: ""
}
const _hoisted_6 = ["value", "selected"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass({
      'tw-flex tw-flex-col': $props.orientation === 'vertical',
      'tw-flex tw-flex-row tw-items-center tw-justify-between': $props.orientation === 'horizontal'
    })
  }, [
    _createElementVNode("div", {
      class: _normalizeClass({
        'tw-mb-1': $props.orientation === 'vertical'
      })
    }, [
      _createElementVNode("div", _hoisted_1, [
        ($props.label)
          ? (_openBlock(), _createElementBlock("label", {
              key: 0,
              for: $props.id,
              class: "tw-block tw-text-xs dark:tw-text-white"
            }, _toDisplayString($props.label), 9, _hoisted_2))
          : _createCommentVNode("", true),
        _renderSlot(_ctx.$slots, "info")
      ]),
      ($props.subLabel)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString($props.subLabel), 1))
        : _createCommentVNode("", true),
      _renderSlot(_ctx.$slots, "subLabel")
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass({
        'tw-bg-white tw-p-0 dark:tw-bg-black dark:tw-text-white': true,
        'tw-w-full': $props.orientation === 'vertical',
        '': $props.orientation === 'horizontal',
        'tw-rounded-md': $props.size === 'regular',
        'tw-rounded': $props.size === 'small',
        'tw-cursor-not-allowed': $props.disabled,
        'tw-cursor-pointer focus-within:tw-ring-deep-orange-500 hover:tw-border-deep-orange-500 focus:tw-border-deep-orange-500':
          !$props.disabled,
        'tw-border': !$props.showError
      })
    }, [
      _createElementVNode("select", {
        id: $props.id,
        "data-testid": $props.id,
        name: $props.id,
        value: $props.value,
        title: $props.disabledReason,
        class: _normalizeClass(["tw-m-0 tw-cursor-pointer", {
          'tw-rounded-md tw-py-2 tw-pl-3 tw-pr-10 tw-text-sm': $props.size === 'regular',
          'tw-rounded tw-py-1 tw-pl-2 tw-pr-10 tw-text-xs': $props.size === 'small',
          'tw-cursor-pointer': !$props.disabled,
          '!tw-cursor-not-allowed': $props.disabled,
          '!tw-border-red-600 focus:tw-border-red-400 focus:tw-ring-red-400 dark:!tw-border-red-400': $props.showError,
          'tw-border-none tw-outline-none': !$props.showError
        }]),
        disabled: $props.disabled,
        onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('change', $event)))
      }, [
        _createElementVNode("option", _hoisted_5, _toDisplayString($props.placeholder), 1),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.options, (option) => {
          return (_openBlock(), _createElementBlock("option", {
            key: option.value,
            value: option.value,
            selected: option.value === $props.value
          }, _toDisplayString(option.label), 9, _hoisted_6))
        }), 128))
      ], 42, _hoisted_4)
    ], 2)
  ], 2))
}